import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Wrapper } from 'components/Ui';

import styles from '../styles.scss';

class Item extends PureComponent {
  render() {
    const {
      props: {
        item: { title, image = {}, quantity, price, relatedFee },
      },
    } = this;

    return (
      <Wrapper color="white" className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.row}>
            <img
              className={styles.image}
              src={image.url}
              alt={image.fileName}
            />
            <div className={styles.column}>
              <div className={styles.boldText}>{title}</div>

              <div className={styles.boldText}>Related Fee</div>
            </div>
          </div>
          <div className={classnames(styles.column, styles.alignEnd)}>
            <div className={styles.row}>
              <div className={styles.selectBlock}>
                <span>Quantity: {quantity}</span>
              </div>
              <div className={styles.priceBlock}>
                <span>${price}</span>
              </div>
            </div>
            <div className={styles.secondaryText}>${relatedFee}</div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

Item.propTypes = {
  item: PropTypes.object.isRequired,
};

export default Item;
